import { render, staticRenderFns } from "./FmyqDetail.vue?vue&type=template&id=d1a3ec08&scoped=true"
import script from "./FmyqDetail.vue?vue&type=script&lang=js"
export * from "./FmyqDetail.vue?vue&type=script&lang=js"
import style0 from "./FmyqDetail.vue?vue&type=style&index=0&id=d1a3ec08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a3ec08",
  null
  
)

export default component.exports